<mat-form-field>

    <input type="text"
           matInput
           #trigger="matAutocompleteTrigger"
           [formControl]="locationControl"
           [placeholder]="('LOCATION' | translate) + ' ' + index"
           [matAutocomplete]="location1AutoGroup"
           (keyup)="updateParamGroupFromKeyboardInput(locationControl.value);">
    <mat-error *ngIf="locationControl.hasError('required')">
        {{'REQUIRED' | translate}}
    </mat-error>
    <mat-error *ngIf="locationControl.hasError('incorrect value')
                      && !locationControl.hasError('required')">
        {{'\'' + locationControl.value + '\' ' + ('IS_NOT_A_LOCATION' | translate)}}
    </mat-error>
    <mat-autocomplete
        #location1AutoGroup="matAutocomplete"
        [displayWith]="mapLocationNameFromId.bind(this)">
        <mat-option
                *ngFor="let location of filteredProjectLocations | async"
                [value]="location.id">
            {{location.name}}
        </mat-option>
    </mat-autocomplete>

</mat-form-field>
